export var ArboLevel;

(function (ArboLevel) {
  ArboLevel["High"] = "HIGH";
  ArboLevel["Low"] = "LOW";
})(ArboLevel || (ArboLevel = {}));